<form role="form"
      [formGroup]="filterForm">
    <div class="form-group">
        <label>Owner</label>
        <adapt-select-person [person]="filter.assignee"
                             (personChange)="onAssigneeChanged($event)"
                             [teamGroup]="team"
                             data-test="filter-objective-assignee"></adapt-select-person>
    </div>

    <div class="form-group">
        <label>Labels</label>
        <adapt-select-label [allowLabelCreation]="false"
                            [labels]="filter.labels"
                            (labelsChange)="onLabelsChanged($event)"
                            data-test="filter-objective-label"></adapt-select-label>
    </div>

    <div class="form-group">
        <label for="preselectionSelectBox"> Statuses </label>
        <dx-tag-box [items]="statuses"
                    [value]="statusSelection"
                    [hideSelectedItems]="true"
                    (valueChange)="onStatusChanged($event)"
                    displayExpr="name"
                    tagTemplate="customTag"
                    data-test="filter-objective-statuses">
            <div *dxTemplate="let data of 'customTag'">
                <div class="dx-tag-content"
                     [ngClass]="data.statusClass">
                    {{ data.name }}
                    <div class="dx-tag-remove-button"></div>
                </div>
            </div>
        </dx-tag-box>
    </div>

    @if (!team && !isAlto) {
        <div class="form-group">
            <label>Include team objectives</label>
            <dx-select-box [value]="teamObjectivesOptionValue"
                           (valueChange)="onTeamObjectivesOptionChanged($event)"
                           [items]="TeamObjectivesOptions"
                           displayExpr="displayText"
                           valueExpr="value"
                           data-test="select-show-team-objectives"> </dx-select-box>
        </div>
    }

    @if (!!team) {
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input"
                       type="checkbox"
                       id="showSupportedObjectives"
                       formControlName="showSupportedObjectives"
                       data-test="toggle-show-supported-org-objectives" />
                <label class="form-check-label"
                       for="showSupportedObjectives"> Show objectives this team supports </label>
            </div>
        </div>
    }

    <div class="form-group">
        <label for="closedObjectives"> When showing closed objectives </label>
        <dx-select-box id="closedObjectives"
                       [value]="filter.closedOption"
                       [disabled]="!closedSelected"
                       (valueChange)="onClosedOptionsChanged($event)"
                       [items]="closedFilters"
                       data-test="select-closed-option"> </dx-select-box>
    </div>

    <div class="form-group">
        <label for="fromDate"> Show Objectives Due From </label>
        <dx-date-box id="fromDate"
                     formControlName="fromDate"
                     width="100%"
                     displayFormat="year"
                     [showClearButton]="true"
                     data-test="filter-from-date">
            <dxo-date-box-calendar-options maxZoomLevel="decade"></dxo-date-box-calendar-options>
        </dx-date-box>
    </div>

    <hr />

    <div class="form-group">
        <label>Focus on</label>
        <dx-select-box [value]="objectiveFilterService.focusType.option$ | async"
                       (valueChange)="onFocussedTypeSelection($event)"
                       [items]="focusOptions"
                       valueExpr="type"
                       displayExpr="label"
                       [showClearButton]="true"
                       data-test="filter-objective-type"></dx-select-box>
    </div>
</form>
